/**
 * Previous and next page for a list read through `useCursorList`. Each
 * button is rendered only when it can act (no dead control), and the page
 * says in words when more rows follow, so a page of rows is never read as
 * the whole list.
 */
import { Button } from "@/components/ui";
import { useTranslation } from "@/lib/i18n";

export function CursorPager({
  page,
  hasMore,
  next,
  previous,
  busy,
}: {
  page: number;
  hasMore: boolean;
  next?: () => void;
  previous?: () => void;
  busy?: boolean;
}) {
  const { t } = useTranslation();
  if (page === 1 && !hasMore) return null;
  return (
    <nav
      aria-label={t("pager.label")}
      className="mt-4"
      style={{
        display: "flex",
        gap: 12,
        alignItems: "center",
        flexWrap: "wrap",
      }}
    >
      <span>{t("pager.page", { page })}</span>
      {hasMore && <span>{t("pager.more")}</span>}
      {previous && (
        <Button size="sm" disabled={busy} onClick={previous}>
          {t("pager.previous")}
        </Button>
      )}
      {next && (
        <Button size="sm" disabled={busy} onClick={next}>
          {t("pager.next")}
        </Button>
      )}
    </nav>
  );
}
